import React from "react";
import * as Animate from "react-reveal";
import ExecutiveLeadersImage from "../../../assets/images/png/mba/executive-leaders.jpg";

const outcomes = [
  [
    "01",
    "Business judgement",
    "Read problems in context and make decisions with a wider view.",
  ],
  [
    "02",
    "Financial fluency",
    "Understand the commercial logic and impact behind your choices.",
  ],
  [
    "03",
    "Leadership confidence",
    "Communicate clearly across teams and with senior stakeholders.",
  ],
  [
    "04",
    "AI fluency",
    "Identify practical ways AI and automation can improve performance.",
  ],
];

const MBAOutcomesSection = () => {
  return (
    <section className="bg-hire-tint-blue py-16 md:py-24 lg:py-28 px-4">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-mba-outcome-intro items-center gap-8 lg:gap-12 mb-8 lg:mb-9">
          <Animate.Fade bottom>
            <div className="max-w-[770px]">
              <p className="flex items-center gap-3 font-poppins text-primary text-sm font-extrabold tracking-widest uppercase mb-5">
                <span className="w-8 h-0.5 bg-secondary inline-block flex-shrink-0"></span>
                What changes for you
              </p>
              <h2 className="font-poppins text-primary font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl leading-tight m-0">
                Move from doing excellent work to understanding what moves the
                business.
              </h2>
            </div>
          </Animate.Fade>

          <Animate.Fade bottom>
            <figure className="relative m-0 rounded-[25px] min-h-[360px] overflow-hidden shadow-[0_22px_58px_#05079421]">
              <img
                src={ExecutiveLeadersImage}
                alt="African business leaders discussing strategy together"
                loading="lazy"
                className="object-cover w-full h-full min-h-[360px] absolute inset-0"
              />
              <figcaption className="text-primary bg-[#fffffff0] rounded-[14px] justify-between gap-5 px-5 py-[18px] flex flex-col sm:flex-row items-start sm:items-center absolute bottom-[18px] left-[18px] right-[18px]">
                <strong className="font-poppins text-base leading-snug">
                  Human judgement first.
                </strong>
                <span className="font-poppins text-gray text-base leading-snug">
                  AI supports the work; people lead it.
                </span>
              </figcaption>
            </figure>
          </Animate.Fade>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {outcomes.map(([number, title, copy]) => (
            <Animate.Fade bottom key={number}>
              <article className="bg-white border border-hire-line border-t-4 border-t-secondary rounded-2xl min-h-[245px] p-7 flex flex-col h-full">
                <span className="font-poppins text-secondary font-extrabold text-sm">
                  {number}
                </span>
                <h3 className="font-poppins text-primary font-semibold text-base mt-auto mb-2">
                  {title}
                </h3>
                <p className="font-poppins text-gray text-sm leading-relaxed m-0">
                  {copy}
                </p>
              </article>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MBAOutcomesSection;
